module.exports = [{"componentChunkName":"component---src-pages-danke-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"danke.json","path":"/danke/"},{"componentChunkName":"component---src-pages-datenschutz-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"datenschutz.json","path":"/datenschutz/"},{"componentChunkName":"component---src-pages-index-js","layout":"layout---index","layoutComponentChunkName":"component---src-layouts-index-js","jsonName":"index.json","path":"/"}]


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 377
// module chunks = 231608221292675